import {
    Medication
} from 'one-state-medication/src/medication';

interface LocalMedication {
    medication: string;
    patientsig: string;
    startdate: string;
    enddate: string;
    refillsremaining: string;
    PrescriptionNumber?: string;
    fillsremaining?:string,
    authorizingprovider?:string,
    prescriptionstatus?:string
}

import { formatIso } from 'one-util-date';


export const sortFunction = (a: Medication, b: Medication) => {
    const dateA = new Date(a?.startdate);
    const dateB = new Date(b?.startdate);
    return dateB.getTime() - dateA.getTime();
}


export const TransformResponse = (response: any, context: any) => {
 ;
    let result: any = {
        medication: [],
        error: undefined
    }
    let combinedData: any = [];
    let medicationobj: LocalMedication = {
        medication: "",
        patientsig: "",
        startdate: "",
        enddate: "",
        refillsremaining: "",
        PrescriptionNumber: "",
        fillsremaining:"",
        authorizingprovider:"",
        prescriptionstatus:""
    }
    const { log, settings } = context;
    const { uisettings: { dateformat } } = settings;
   

    if (response && (response.status >= 400 || response.type == "error")) {
        result.error = response;
    }
//     response=[
//         {
//             "PrescriptionNumber":"0000105", // PrescriptionNumber from prescription
// "Name":"aspirin 81 MG tablet",
// "AuthorizingProviderDisplayName":"Outpatient Physician Family Medicine, MD",
// "Status":"Shipped", //status from prescription
// "PatientSig":"Take 1 tablet (81 mg total) by mouth 2 (two) times a day if needed.", //PatientSig from medication
// "StartDate":"2022-04-08T00:00:00Z", // from medication
// "EndDate":"2022-05-08T00:00:00Z", // from medication
// "RefillsRemaining":null, // from medication
// "FillsRemaining": null // from prescription
//         }
//     ]
    if (response?.length > 0) {
        let deliverytyperarray: any = [];
        response?.forEach((presele: any) => {

            medicationobj = {
            medication:presele?.Name ? presele.Name : "",

            patientsig: presele?.PatientSig ? presele.PatientSig : "",
            startdate: presele?.StartDate ? formatIso(presele.StartDate, dateformat) : "N/A",
            enddate: presele?.EndDate ? formatIso(presele.EndDate, dateformat) : "N/A",
            refillsremaining: presele?.RefillsRemaining?.toString() ? presele.RefillsRemaining : "",
            PrescriptionNumber: presele?.PrescriptionNumber ? presele.PrescriptionNumber : "",
            fillsremaining : presele?.FillsRemaining?.toString() ? presele.FillsRemaining : "",
            authorizingprovider : presele?.AuthorizingProviderDisplayName ? presele.AuthorizingProviderDisplayName : "",
            prescriptionstatus :presele?.Status ? presele.Status : ""

            }
            combinedData.push(medicationobj)
          
        });
    }
    console.log("responsemedpresc", combinedData);
    result.combinedData = combinedData;

    log.debug(
        "ccw-gadget,medicationinfo-epic",
        "medicationinfo-epic transforamtion response ", {
        result
    });
    return result.combinedData;
}
